import { render } from "./FormData.vue?vue&type=template&id=7369f2f6&ts=true"
import script from "./FormData.vue?vue&type=script&lang=ts"
export * from "./FormData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__